const locale: Locale = {
  ko: {
    consent: '동의합니다',
    signBtn: '동의하기',
    signedBtn: '동의완료',
  },
  en: {
    consent: 'I agree to this',
    signBtn: 'Agree',
    signedBtn: 'Agreed',
  },
}

export default locale
